import Icon from '../components/Icon.vue'

Icon.register({"chart-line":{"width":512,"height":512,"paths":[{"d":"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM456 96H344C322.6 96 311.9 121.9 327 137L359.9 169.9 287.9 242.8 232.3 187.2C227.6 182.5 220.1 182.5 215.4 187.2L96.4 305C91.7 309.6 91.6 317.2 96.2 321.9L124.7 351.3C129.4 356.1 137.1 356.2 141.8 351.4L223.9 269.3 279.4 324.8C284.1 329.5 291.7 329.5 296.4 324.8L405.6 215.6 439 249C454.1 264.1 480 253.4 480 232V120C480 106.7 469.3 96 456 96z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/chart-line.js